import { render, staticRenderFns } from "./invoice-v2.vue?vue&type=template&id=f189f456"
import script from "./invoice-v2.vue?vue&type=script&lang=js"
export * from "./invoice-v2.vue?vue&type=script&lang=js"
import style0 from "./invoice-v2.vue?vue&type=style&index=0&id=f189f456&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports